import { CCard, CCardHeader, CCol, CFormLabel, CFormInput } from '@coreui/react';
import { useIntl } from 'react-intl';
import useCustomerDataAnalytics from 'hooks/useCustomerDataAnalytics';
import Loading from 'components/common/Loading';
import usePagination from 'hooks/usePagination';
import CustomerDataAnalyticsTable from 'components/customerDataAnalytics/CustomerDataAnalyticsTable';
import useFilterValue from 'hooks/useFilterValue';
import Button from 'components/common/Button';
import { Link } from 'react-router-dom';
import routePaths from 'router/route-paths';
import s from './CustomerDataAnalytics.module.scss';

const CustomerDataAnalytics = () => {
  const { formatMessage: t } = useIntl();
  const { currentPage, changePage } = usePagination({ nameOfRoute: 'customerDataAnalytics' });
  const { filter, handleChange, debouncedFilterValue } = useFilterValue({ changePage });
  const { customerDataRecords, total, loading } = useCustomerDataAnalytics({
    currentPage,
    filter: debouncedFilterValue,
  });

  return (
    <CCol xs={12} lg={12}>
      <CCard>
        <CCardHeader className={s.header}>
          <h4>{t({ id: 'page_titles.customer_data_analytics' })}</h4>
          <Link to={routePaths.reports}>
            <Button color="primary">{t({ id: 'reports.generate_report' })}</Button>
          </Link>
        </CCardHeader>

        <div className="mb-3">
          <CFormLabel htmlFor="filter">{t({ id: 'projects.filter' })}</CFormLabel>
          <CFormInput
            id="filter"
            type="search"
            name="filter"
            value={filter}
            onChange={handleChange}
          />
        </div>

        {!loading ? (
          <CustomerDataAnalyticsTable
            {...{ customerDataRecords, currentPage, changePage, total, t }}
          />
        ) : (
          <Loading size={30} />
        )}
      </CCard>
    </CCol>
  );
};

export default CustomerDataAnalytics;
